<template>
  <el-container v-loading="isLoading">
    <el-header>
      <ul class="List-headr">
        <li>
          <el-button v-if="addPower" type="primary" icon="el-icon-plus" size="small" @click="setAddAndModify(false)">新建投放单元</el-button>
        </li>
        <li v-if="isSspUser">
          <span>所属广告主：</span>
          <el-select size="small" v-model="queryUser" @change="myOption.restStartPage();setUserId();">
            <el-option v-for="(item, index) in userData" :label="item.advertiserName" :value="item.advertiserId" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>投放单元名称：</span>
          <el-input size="small" placeholder="请输入内容" prefix-icon="el-icon-search" v-model="queryUnitName" @input="getList"></el-input>
        </li>
        <li>
          <span>状态：</span>
          <el-select size="small" v-model="queryStatus" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in myOption.status" :label="item.name" :value="item.id" :key="index"></el-option>
          </el-select>
        </li>
        <li>
          <span>投放计划：</span>
          <el-select size="small" v-model="queryPlan" @change="myOption.restStartPage();getList();">
            <el-option v-for="(item, index) in planData" :label="item.planName" :value="item.planId" :key="index"></el-option>
          </el-select>
        </li>
      </ul>
    </el-header>
    <el-main class="ListMain">
      <el-table :data="tableData" height="100%">
        <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="ListMain-table-expand">
              <el-form-item label="创建时间">
                <span>{{ props.row.createTime }}</span>
              </el-form-item>
              <el-form-item label="最后修改时间">
                <span>{{ props.row.updateTime }}</span>
              </el-form-item>
              <el-form-item label="修改人">
                <span>{{ props.row.modifier }}</span>
              </el-form-item>
              <el-form-item label="备注">
                <span>{{ props.row.remark }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column prop="putUnitId" label="ID" min-width="100px"></el-table-column>
        <el-table-column prop="putUnitName" label="投放单元名称" min-width="200px"></el-table-column>
        <el-table-column prop="slotType" label="代码位类型" min-width="150px"></el-table-column>
        <el-table-column prop="assignSlot" label="代码位定向" min-width="200px"></el-table-column>
        <el-table-column prop="planInfoVo.planName" label="投放计划名称" min-width="150px"></el-table-column>
        <el-table-column prop="flowTypeText" label="流量类型" min-width="150px"></el-table-column>
        <el-table-column label="创意统计" min-width="150px">
          <el-button v-if="ideaPower" type="text" slot-scope="scope" @click="jumpUnit(scope.row)">{{scope.row.ideaNum}}</el-button>
          <span v-else>{{scope.row.ideaNum}}</span>
        </el-table-column>

        <!--
        <el-table-column prop="status" label="状态" min-width="100px">
          <template slot-scope="scope">
            <el-switch v-model="tableData[scope.$index].status" :disabled="!statusPower" active-color="#13ce66" inactive-color="#ff4949" :active-value="1" :inactive-value="0" @change="setStatus(tableData[scope.$index])"></el-switch>
          </template>
        </el-table-column>
        -->

        <el-table-column v-if="addPower || deletePower || modifyPower" min-width="150px">
          <template slot="header" slot-scope="scope">
            操作
            <i class="el-icon-question" title="创意统计 >0 时，禁用删除操作"></i>
          </template>
          <template slot-scope="scope">
            <el-button v-if="addPower" type="text" size="small" style="color:#67C23A;" @click="setAddAndModify(tableData[scope.$index], true)">复制</el-button>
            <el-button v-if="modifyPower" type="text" size="small" @click="setAddAndModify(tableData[scope.$index])">修改</el-button>
            <el-button v-if="deletePower && tableData[scope.$index].ideaNum===0" type="text" size="small" style="color: #F56C6C" @click="setDelete(tableData[scope.$index])">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-main>
    <el-footer>
      <Pagination :getList="getList"></Pagination>
    </el-footer>
  </el-container>
</template>

<script>
import Pagination from '../Pagination'
export default {
  name: 'List',
  components: {
    Pagination
  },
  data () {
    return {
      isSspUser: this.$store.getters.isMediaOwner,
      isLoading: true,
      thisModule: [],
      tableData: [],
      addPower: false,
      deletePower: false,
      modifyPower: false,
      statusPower: false,
      userData: [],
      queryUser: this.$route.params.advertiserId || '',
      queryStatus: '',
      queryUnitName: '',
      queryPlan: this.$route.params.planId || '',
      planData: [{planName: '不限', planId: ''}],
      ideaPower: false
    }
  },
  created () {
    // 获取模块配置
    let thisModule = this.myOption.requestModule.unit.children
    // 获取功能权限
    this.$store.dispatch('GetPowerList').then((powers) => {
      let power = powers[500].powerValue
      // 新建
      if ((power & thisModule.add.power) === thisModule.add.power) {
        this.addPower = true
      }
      // 删除
      if ((power & thisModule.delete.power) === thisModule.delete.power) {
        this.deletePower = true
      }
      // 修改
      if ((power & thisModule.modify.power) === thisModule.modify.power) {
        this.modifyPower = true
      }
      // 启用/禁用
      if ((power & thisModule.status.power) === thisModule.status.power) {
        this.statusPower = true
      }
      // 创意跳转
      const ideaPower = powers[700].powerValue
      const ideaPowerList = this.myOption.requestModule.idea.children.list.power
      if ((ideaPower & ideaPowerList) === ideaPowerList) {
        this.ideaPower = true
      }
    })
    // 缓存模块配置
    this.thisModule = thisModule
    // 获取缓存筛选数据
    this.myOption.getScreenData(this, 'screen-unit')
    // 判断是否为媒体主
    if (this.isSspUser) {
      this.getAdOwnerList().then(() => {
        // 调用获取投放计划列表函数
        this.getPlanList().then(() => {
          // 调用获取列表函数
          this.getList()
        })
      })
    } else {
      // 调用获取投放计划列表函数
      this.getPlanList().then(() => {
        // 调用获取列表函数
        this.getList()
      })
    }
  },
  methods: {
    // 获取广告主列表
    getAdOwnerList () {
      return new Promise((resolve) => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.list.id
          },
          url: this.myOption.requestUrl + this.thisModule.list.user,
          data: this.qs.stringify({
            startPage: 1,
            pageSize: this.myOption.pageSize.max
          })
        }).then(res => {
          const code = res.data.code
          if (code === 200) {
            this.userData = res.data.data.data
            this.myOption.appendSelectAllItem('advertiser', this.userData)
            if (this.$route.path.indexOf('/list') > -1 && !this.queryUser) {
              try {
                this.queryUser = this.userData[0].advertiserId
                resolve && resolve()
              } catch (e) {
                this.isLoading = false
              }
            } else {
              resolve && resolve()
            }
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      })
    },
    // 获取投放计划列表
    getPlanList () {
      return new Promise((resolve) => {
        let param = {
          startPage: 1,
          pageSize: this.myOption.pageSize.max
        }
        if (this.isSspUser) {
          param.advertiserId = this.queryUser
        }
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.list.id
          },
          url: this.myOption.requestUrl + this.thisModule.list.plan,
          data: this.qs.stringify(param)
        }).then((res) => {
          let code = res.data.code
          if (code === 200) {
            this.planData = [...this.planData, ...res.data.data.data]
          } else {
            this.myOption.abnormalCode(this, code)
          }
          resolve()
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      })
    },
    // 设置广告主
    setUserId () {
      this.queryPlan = ''
      this.planData = [{planName: '不限', planId: ''}]
      // 调用获取投放计划列表函数
      this.getPlanList().then(() => {
        // 调用获取列表函数
        this.getList()
      })
    },
    // 获取列表
    getList () {
      let param = {
        putUnitName: this.queryUnitName,
        status: this.queryStatus,
        planId: this.queryPlan,
        startPage: this.$store.state.user.currentPage,
        pageSize: this.$store.state.user.pageSize
      }
      if (this.isSspUser) {
        param.advertiserId = this.queryUser
      }
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.list.id
        },
        url: this.myOption.requestUrl + this.thisModule.list.api,
        data: this.qs.stringify(param)
      }).then(res => {
        const code = res.data.code
        if (code === 200) {
          let data = res.data.data.data
          for (let val of data) {
            val.slotType = this.myOption.getIdData('slotType', val.slotType, 'name')
            val.flowTypeText = this.myOption.getIdData('flowType', val.flowType, 'name')
          }
          this.tableData = data
          this.$store.dispatch('SetPageTotal', res.data.data.totalSize)
        } else {
          this.myOption.abnormalCode(this, code)
        }
        this.isLoading = false
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        this.isLoading = false
      })
    },
    // 新增和修改
    setAddAndModify (data, isCopy) {
      if (data) {
        this.$store.dispatch('SetEditId', {id: data.putUnitId, copy: isCopy || false})
      }
      let param = {}
      if (this.queryUser !== '') {
        param.queryUser = this.queryUser
      }
      if (this.queryUnitName !== '') {
        param.queryUnitName = this.queryUnitName
      }
      if (this.queryPlan !== '') {
        param.queryPlan = this.queryPlan
      }
      if (this.queryStatus !== '') {
        param.queryStatus = this.queryStatus
      }
      if (this.$store.state.user.currentPage !== 1) {
        param.startPage = this.$store.state.user.currentPage
      }
      if (this.$store.state.user.pageSize !== 10) {
        param.startPage = this.$store.state.user.pageSize
      }
      if (Object.keys(param).length > 0) {
        window.sessionStorage.setItem('screen-unit', JSON.stringify(param))
      }
      this.myOption.switchListAndEdit(this, false)
    },
    // 删除
    setDelete (param) {
      this.$confirm(`是否删除 "${param.putUnitName}" 投放单元`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios({
          method: 'post',
          headers: {
            'Authorization': this.$store.state.user.token,
            'ModuleId': this.thisModule.delete.id
          },
          url: this.myOption.requestUrl + this.thisModule.delete.api,
          data: this.qs.stringify({
            putUnitIds: param.putUnitId
          })
        }).then(res => {
          const code = res.data.code
          if (res.data.code === 200) {
            this.$message.success('删除投放单元成功')
            this.getList()
          } else {
            this.myOption.abnormalCode(this, code)
          }
        }).catch((err) => {
          this.myOption.abnormalCode(this, err)
        })
      }).catch(() => {})
    },
    // 启用/禁用
    setStatus (param) {
      this.$axios({
        method: 'post',
        headers: {
          'Authorization': this.$store.state.user.token,
          'ModuleId': this.thisModule.status.id
        },
        url: this.myOption.requestUrl + this.thisModule.status.api,
        data: this.qs.stringify({
          putUnitId: param.putUnitId,
          status: param.status
        })
      }).then(res => {
        const code = res.data.code
        if (res.data.code === 200) {
          this.$message.success(`${param.status === 1 ? '启用' : '禁用'}投放单元成功`)
        } else {
          this.myOption.abnormalCode(this, code)
          param.status = !param.status
        }
      }).catch((err) => {
        this.myOption.abnormalCode(this, err)
        param.status = !param.status
      })
    },
    // 跳转投放单元
    jumpUnit (param) {
      this.$router.push({
        path: '/idea/list',
        name: '创意管理',
        params: {
          unitId: param.putUnitId,
          planId: param.planInfoVo.planId,
          advertiserId: this.queryUser
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/unit/List.vue